import { render, staticRenderFns } from "./recoverpwd.vue?vue&type=template&id=5ff29840&"
import script from "./recoverpwd.vue?vue&type=script&lang=js&"
export * from "./recoverpwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports